import has from 'lodash/has';
import isPlainObject from 'lodash/isPlainObject';
import omit from 'lodash/omit';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { createLocalStorageStateHook } from 'use-local-storage-state';

import { selectUserId } from 'selectors/user';
import { selectWorkspaceId } from 'selectors/workspace';

export function createLocalWorkspaceStateHook(key) {
  const useLocalStorageState = createLocalStorageStateHook(key);

  return function useLocalWorkspaceState(key, defaultValue) {
    const userId = useSelector(selectUserId);
    const workspaceId = useSelector(selectWorkspaceId);
    const id = `${userId}:${workspaceId}`;
    const [state, setState] = useLocalStorageState(key);

    let value = defaultValue;

    if (state && userId && workspaceId) {
      value = state[id];
    }

    const setValue = useCallback(
      value => {
        const prev = isPlainObject(state) ? state : {};

        setState({ ...prev, [id]: value });
      },
      [id, setState, state]
    );

    const removeValue = useCallback(() => {
      if (has(state, id)) {
        setState(omit(state, id));
      }
    }, [id, setState, state]);

    return [value, setValue, removeValue];
  };
}
